import qs from 'qs';
import request from '../index';
/** 成品仓库 **/

/** 
* FQC
* @params {string} data.assembleDebugsnNumber 总装调试SN号
* @params {string} data.batchNumber 生产批号
* @params {string} data.closedLoopStatus 闭环状态
* @params {number} data.id 
* @params {number} data.inspectionFrequency 送检次数
* @params {string} data.inspectionIssues 送检问题
* @params {string} data.localDate 生产日期
* @params {string} data.modelSpecifications 型号规格
* @params {string} data.notes 备注
* @params {number} data.oqcId 
* @params {number} data.pqcId 
* @params {string} data.produceOrTpc 生产模块or试产中心
* @params {string} data.serial 机身号
* @params {string} data.serialNumber 流水号
* @params {string} data.status 状态：合格/不合格/未检
* @params {number} data.userId 
* @params {string} data.username 
*/

/** 
* 合格总装调试转为FQC
* @params {number} params.pqcId 总装调试id
*/
export const PQCToFQC = (params) => request.get('/api-qc/PQCToFQC', { params });

/** 
* FQC成品库存
* @params {string} params.localDate localDate
* @params {string} params.produceOrTpc 生产或者试产
*/
export const getFQCInventory = (params) => request.get('/api-qc/getFQCInventory', { params });

/** 
* 获得FQC列表
* @params {string} params.endDate 结束时间
* @params {number} params.inspectionFrequency 送检次数
* @params {number} params.lineNum 每页显示多少条
* @params {string} params.localDate 日期
* @params {string} params.modelSpecifications 型号规格
* @params {number} params.pageNum 页码
* @params {string} params.produceOrTpc 生产或者试产
* @params {string} params.questionType 问题类型
* @params {string} params.search search
* @params {string} params.startDate 开始时间
* @params {string} params.status 状态：合格/不合格/未检
*/
export const getFQCList = (params) => request.get('/api-qc/getFQCList', { params });

/** 
* FQC合格库存列表
* @params {string} params.modelSpecifications 项目型号规格
* @params {string} params.produceOrTpc 生产模块or试产中心
*/
export const getFQCQualifiedList = (params) => request.get('/api-qc/getFQCQualifiedList', { params });

/** 
* 增加发货指令
* @params {OQC} oqc
*/
export const insertOQC = (data) => request.post('/api-qc/insertOQC', data);

/** 
* FQC合格率汇总
* @params {string} params.endDate 结束时间
* @params {string} params.localDate 日期
* @params {string} params.produceOrTpc 生产或者试产
* @params {string} params.startDate 开始时间
*/
export const getFQCQualifiedSituation = (params) => request.get('/api-qc/getFQCQualifiedSituation', { params });

/** 
* 更新FQC
* @params {FQC} fqc
* @params {string} params.isQualityInspection 是否质检更新
*/
export const updateFQC = (params, data) => request.put(`/api-qc/updateFQC?${qs.stringify(params)}`, data);

/** 
* 更新OQC
* @params {OQC} oqc
*/
export const updateOQC = (data) => request.put('/api-qc/updateOQC', data);

/** 
* 获得OQC列表
* @params {string} params.batchNumber 生产批号
* @params {string} params.endDate 结束时间
* @params {number} params.inspectionFrequency 送检次数
* @params {number} params.lineNum 每页显示多少条
* @params {string} params.localDate 日期
* @params {string} params.modelSpecifications 型号规格
* @params {number} params.pageNum 页码
* @params {string} params.produceOrTpc 生产或者试产
* @params {string} params.questionType 问题类型
* @params {string} params.search search
* @params {string} params.startDate 开始时间
* @params {string} params.status 状态：合格/不合格/未检
*/
export const getOQCList = (params) => request.get('/api-qc/getOQCList', { params });

/** 
* 获得天鹅包装配件
* @params {string} params.oqcId oqcId
*/
export const getSwanAccessory = (params) => request.get('/api-qc/getSwanAccessory', { params });


/**
 * 添加or更新天鹅配件
*/
export const saveSwanAccessory = (data) => request.put('/api-qc/saveSwanAccessory', data);

/**
 * OQC导出
*/
export const exportOQC = () => request.get('/api-qc/exportOQC', { responseType: 'blob' });
